export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/BuyFromSylndr.ef4a8e39.svg","height":96,"width":122,"blurWidth":0,"blurHeight":0};